import { Link } from "react-router-dom";
import siteData from "../data/siteData.json";

function Footer() {
  const { company } = siteData;

  return (
    <footer className="footer-section">
      <div className="container-fluid">
        <div className="footer-content pt-5 pb-5">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-6 mb-30">
              <div className="footer-widget">
                <div className="footer-text">
                  <p>{company.footerAbout}</p>
                </div>
                <div className="footer-social-icon mt-3">
                  <a
                    href={company.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-facebook-f facebook-bg"></i>
                  </a>
                  <a
                    href={company.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-linkedin linkedin-bg"></i>
                  </a>
                  <a
                    href={company.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-instagram instagram-bg"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 mb-30">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Quick Links</h3>
                </div>
                <ul className="quick-links">
                  <li>
                    <Link to="/">HOME</Link>
                  </li>
                  <li>
                    <Link to="/about">ABOUT US</Link>
                  </li>
                  <li>
                    <Link to="/news">NEWS</Link>
                  </li>
                  <li>
                    <Link to="/careers">CAREERS</Link>
                  </li>
                  <li>
                    <Link to="/contact">CONTACT US</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 mb-30">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>PROJECTS</h3>
                </div>
                <ul className="quick-links">
                  <li>
                    <Link to="/ongoing-project">Ongoing Projects</Link>
                  </li>
                  <li>
                    <Link to="/upcoming-project">Upcoming Projects</Link>
                  </li>
                  <li>
                    <Link to="/complete-project">Completed Projects</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 mb-30">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>APPOINTMENT</h3>
                </div>
                <div className="footer-text mt-3">
                  <p>
                    <i className="fa fa-map-marker"></i> {company.address}
                  </p>
                  <p>
                    <i className="fa fa-phone"></i>
                    <a href={company.phoneHref}>{company.phone}</a>
                  </p>
                  <p>
                    <i className="fa fa-envelope"></i>
                    <a href={`mailto:${company.email}`}>
                      {company.email}
                    </a>
                  </p>
                  <Link
                    to="/contact"
                    className="btn btn-primary mt-3"
                    style={{
                      backgroundColor: "#4a352a",
                      borderColor: "#4a352a",
                      width: "100%",
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    <i className="fa fa-calendar-check-o"></i> Contact Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-area">
        <div className="container">
          <div className="copyright-text">
            <p>
              &copy; {new Date().getFullYear()}{" "}
              <a
                href={company.website}
                target="_blank"
                rel="noreferrer"
              >
                {company.website.replace("https://", "")}
              </a>{" "}
              All rights reserved. Designed By:{" "}
              <a href={company.designedByUrl} target="_blank" rel="noreferrer">
                {company.designedBy}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;